export class SearchInsuranceModel {
  patientAccount: any;
  providerCode: any;
  practiceCode: any;
  insuranceName: any;
  zip: any;
  pageIndex: any;
  pageSize: any;
  patientState: any;
  groupName: any;
  flag: any;
  callFrom: any;
}
export class AddInsuranceModel {
  patientAccount: any="";
  type: any="";
  practiceCode: any="";
  insuranceId: any="";
  groupName: any="";
  groupId: any="";
  policyNumber: any="";
  copay: any="";
  relationship: any="";
  copayPercent: any="";
  deductable: any="";
  allowedVisit: any="";
  effectiveFrom: any="";
  effectiveTo: any="";
  wcInfo: any="";
  subscriber: any="";
  createdBy: any="";
  guarantoR_CODE: any="";
  addedFrom: any = "Manual";
}
export class SerchInsuranceResponceModel {
  inspayeR_DESCRIPTION: any;
  insName_Id: any;
  insurancE_ID: any
  insurancE_ADDRESS: any;
  insurancE_ZIP: any;
  insurancE_STATE: any;
  insurancE_CITY: any;
  insurancE_DEPARTMENT: any;
  phone: any;
  fax: any;
  inspayeR_ID: any;
  inspayeR_837_ID: any;
  grouP_NAME: any;
  grouP_ID: any;
  setuP_NAME: any;
  insPayer_Eligibility_Id: any;
}
export class UpdateInsuranceModel {
  
  patientInsuranceId: any
  patientAccount: any
  type: any
  insuranceId: any
  groupName: any
  groupId: any
  policyNumber: any
  copay: any
  relationship: any
  copayPercent: any
  deductable: any
  allowedVisit: any
  effectiveFrom: any
  effectiveTo: any
  wcInfo: any
  subscriber: any
  createdBy: any
  practiceCode: any
  
}
export class UpdateSubscriberInfo {
  patientAccount: string = '';
  practiceCode: string = '';
  guaranT_LNAME: string = '';
  guaranT_FNAME: string = '';
  guaranT_MI: string = '';
  guaranT_ADDRESS: string = '';
  guaranT_CITY: string = '';
  guaranT_STATE: string = '';
  guarant_zip: string = '';
  guarant_dob: any = '';
  guaranT_SSN: string = '';
  guaranT_GENDER: string = '';
  guaranT_HOME_PHONE: string = '';
  guaranT_WORK_PHONE: string = '';
  guaranT_WORK_PHONE_EXT: string = '';
  guarantoR_CODE: string = '';
  modified_By: string = '';
  GUARANT_PRACTICE_CODE: string = '';
  GUARANT_TYPE: string = '';
}
export class PatienT_INSURANCE_INFO {
  
  patienT_INSURANCE_ID: string = '';
  co_Payment: string = '';
  deductions: string = '';
  effective_Date: string = ''
  termination_Date: string = '';
  group_Name: string = '';
  filing_indicator: string = '';
  cO_PAYMENT_PER: string = '';
  group_Number: string = '';
  allowed_Visits: string = '';
  patienT_ACCOUNT: string = '';
  prI_SEC_OTH_TYPE: string = '';
  id: string = '';
  policY_NUMBER: string = '';
  relationship: string = '';
  date: string = '';
  inspayeR_DESCRIPTION: string = '';
  subscriber: string = '';
  insurancE_ID: string = '';
  insurancE_ADDRESS: string = '';
  insurancE_CITY: string = '';
  insurancE_STATE: string = '';
  insurancE_ZIP: string = '';
  relationshiP_DESCRIPTION: string = '';
  guarantoR_CODE: string = '';
  is_OCR_exist: boolean;
  insurancE_STATUS: any;
  pcP_STATUS: any;
}
export class AddSubscriberResponse {
  guarantorCode: string = "";
}
export class getSubscriberDetails {
  patient_Account: any;
  guarantoR_CODE: any;
  guaranT_LNAME: any;
  guaranT_FNAME: any;
  guaranT_MI: any;
  guaranT_ADDRESS: any;
  guaranT_CITY: any;
  guaranT_STATE: any;
  guaranT_ZIP: any;
  guaranT_DOB: any;
  guaranT_SSN: any;
  guaranT_GENDER: any;
  guaranT_HOME_PHONE: any;
  guaranT_WORK_PHONE: any;
  guaranT_WORK_PHONE_EXT: any;
  guarant_practice_code: any;
  guarant_Type: any;
  createD_BY: any;
  created_date: any;
  sync_date: any;
}
export class OcrResponce
{ 
  ['Effective Date']: any;
  ['Electronic Payer ID']: any;
  ['Group Number']: any;
  ['Insurance ID']: any;
  ['Insurance Name']: any;
  ['Medical Claim Address']: any;
  ['Patient Name']: any;
}
export class OcrResponceNew {
  Insurance_Id:any
  InsPayer_Description: any
  InsName_Id: any
  InsGroup_Id: any
  InsGroup_Name: any
  policyNumber: any
  Confidence_Score: any
}

export class DeleteInsuranceModel {
  patientAccount: any;
  insuranceId: any;
  modifiedBy: any;
  practiceCode:any;
}
export class UpdatePatientSelfPayBitRequest
{
  patientAccount: any;
  practiceCode: any;
  isSelfPay: any;
}
